"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUpdateDto = generateUpdateDto;
exports.generateCreateDto = generateCreateDto;
exports.generateOmitDto = generateOmitDto;
const mocks_1 = require("../mocks");
__exportStar(require("./id.query.param.dto"), exports);
__exportStar(require("./generate.gateway.token.dto"), exports);
function generateUpdateDto(model, keys) {
    return (0, mocks_1.PartialType)((0, mocks_1.PickType)(model, keys));
}
function generateCreateDto(model, keys) {
    return (0, mocks_1.PickType)(model, keys);
}
function generateOmitDto(model, keys) {
    return (0, mocks_1.OmitType)(model, keys);
}
